/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var footer_parallax = document.getElementById('footer-parallax');

  if(!footer_parallax) {
    return;
  }

  var footer_parallax_list = footer_parallax.querySelector('ul');

  const animation_footer_parallax = function() {
    var to = 125,
        move = (window.innerWidth / 2) / 100;

    if(window.innerWidth > 1030) {
      to = 200;
    }

    var percentage = get_percentage_from_top(footer_parallax);
    if(percentage <= 0) {
      return;
    }

    footer_parallax_list.style.left = ((to + (move * percentage)) * -1) + 'px';
  };

  addEventListener('DOMContentLoaded', animation_footer_parallax, false);
  addEventListener('load', animation_footer_parallax, false);
  addEventListener('scroll', animation_footer_parallax, false);
  addEventListener('resize', animation_footer_parallax, false);
  addEventListener('tab-opened', animation_footer_parallax, false);

  function get_percentage_from_top(element) {
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight;
    const bounds = element.getBoundingClientRect();
    const elementOffsetTop = bounds.y;

    return Math.round(((viewportHeight - elementOffsetTop) / viewportHeight) * 100);
  }
})();